import { Search } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const SearchBar = ({ categories = [], compact = false }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const submit = (event) => {
    event.preventDefault();
    const params = new URLSearchParams();
    if (query) params.set("q", query);
    if (category) params.set("category", category);
    navigate(`/machines?${params}`);
  };
  return (
    <form onSubmit={submit} className={`grid gap-2 bg-white p-2 shadow-2xl ${compact ? "md:grid-cols-[1fr_180px_auto]" : "md:grid-cols-[1fr_220px_auto]"}`} data-testid="marketplace-search-form">
      <label className="flex min-w-0 items-center gap-3 px-4">
        <Search className="h-5 w-5 shrink-0 text-orange-500" />
        <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search manufacturer, model or machine" className="h-12 min-w-0 flex-1 bg-transparent text-slate-950 outline-none placeholder:text-slate-500" data-testid="marketplace-search-input" />
      </label>
      <select value={category} onChange={(event) => setCategory(event.target.value)} className="h-12 border-l-0 border-slate-200 bg-slate-100 px-4 text-sm font-semibold text-slate-900 outline-none md:border-l" data-testid="marketplace-category-select">
        <option value="" label="All categories" />
        {categories.map((item) => <option key={item.slug} value={item.slug} label={item.name} />)}
      </select>
      <button className="inline-flex h-12 items-center justify-center gap-2 bg-orange-500 px-7 font-bold uppercase text-white hover:bg-orange-600" data-testid="marketplace-search-button"><Search className="h-4 w-4" /> Search</button>
    </form>
  );
};